// Types for the voice assistant agent, ported from the React reference
// implementation in st-general-assistant.

export interface ConversationTurn {
  role: 'user' | 'assistant';
  transcript: string;
  timestamp: Date;
}

export interface VoiceAgentState {
  isConnected: boolean;
  isRecording: boolean;
  isSpeaking: boolean;
  error: string | null;
  userTranscript: string;
  agentTranscript: string;
  conversationHistory: ConversationTurn[];
  // Force the next assistant response into a new bubble (after an interruption).
  forceNewBubble: boolean;
}

export const initialVoiceAgentState: VoiceAgentState = {
  isConnected: false,
  isRecording: false,
  isSpeaking: false,
  error: null,
  userTranscript: '',
  agentTranscript: '',
  conversationHistory: [],
  forceNewBubble: false
};

// ---- Wire protocol (must match the agent) ----

// Client -> agent
export interface BidiAudioInputEvent {
  type: 'bidi_audio_input';
  audio: string; // base64 PCM
  format: 'pcm';
  sample_rate: number;
  channels: number;
}

// Agent -> client message shapes
export interface BidiAudioStreamEvent {
  type: 'bidi_audio_stream';
  audio: string; // base64 PCM
  format?: string;
  sample_rate?: number;
}

export interface BidiTranscriptStreamEvent {
  type: 'bidi_transcript_stream';
  text?: string;
  is_final?: boolean;
  role?: 'user' | 'assistant';
}

export interface BidiTextResponseEvent {
  type: 'bidi_text_response';
  text: string;
}

export interface BidiInterruptionEvent {
  type: 'bidi_interruption';
  reason?: string;
}
